import React, { useState } from "react";
import {
  ProjectCard,
  ProjectCardContent,
  ProjectCardDescription,
  ProjectCardImage,
  ProjectCardList,
  ProjectCardTitle,
  ProjectCompanyContainer,
  ProjectCompanyHeader,
  ProjectCompanyName,
  ProjectCompanyTimeline,
  ProjectListSectionContainer,
  ProjectSectionHeader,
  ProjectSectionTitle,
  ProjectView,
  ProjectViewButton,
  ProjectViewControls,
} from "./style";

import data from "../../../../data/home";
import { ProjectDataProps } from "../../../../data/home/props";
import { Link } from "react-router-dom";

const renderProject = (projects: ProjectDataProps[], view: ProjectView) =>
  projects.map((project) => {
    const card = (
      <ProjectCard view={view}>
        {view === "gallery" && (
          <ProjectCardImage
            view={view}
            background={project.thumbnailBackground}
          >
            <img
              src={project.image}
              alt=""
              style={{
                objectFit: project.thumbnailFit || "cover",
                objectPosition: project.thumbnailPosition || "center",
                transform: `scale(${project.thumbnailScale || 1})`,
              }}
            />
          </ProjectCardImage>
        )}
        <ProjectCardContent view={view}>
          <ProjectCardTitle view={view}>{project.title}</ProjectCardTitle>
          <ProjectCardDescription>{project.description}</ProjectCardDescription>
        </ProjectCardContent>
        {view === "list" && (
          <ProjectCardImage
            view={view}
            background={project.thumbnailBackground}
          >
            <img
              src={project.image}
              alt=""
              style={{
                objectFit: project.thumbnailFit || "cover",
                objectPosition: project.thumbnailPosition || "center",
                transform: `scale(${project.thumbnailScale || 1})`,
              }}
            />
          </ProjectCardImage>
        )}
      </ProjectCard>
    );

    if (project.external) {
      return (
        <a
          key={project.title}
          href={project.path}
          target="_blank"
          rel="noreferrer"
          style={{ display: "block", textDecoration: "none" }}
        >
          {card}
        </a>
      );
    }

    return (
      <Link
        key={project.title}
        style={{ display: "block", textDecoration: "none" }}
        to={project.path}
      >
        {card}
      </Link>
    );
  });

const renderCompanies = (view: ProjectView) =>
  data.companies.map((company) => (
    <ProjectCompanyContainer key={company.name} view={view}>
      <ProjectCompanyHeader view={view}>
        <ProjectCompanyName view={view}>{company.name}</ProjectCompanyName>
        <ProjectCompanyTimeline view={view}>
          {company.timeline}
        </ProjectCompanyTimeline>
      </ProjectCompanyHeader>
      <ProjectCardList view={view}>
        {renderProject(company.projects, view)}
      </ProjectCardList>
    </ProjectCompanyContainer>
  ));

const ProjectListSection = () => {
  const [view, setView] = useState<ProjectView>("list");

  return (
    <ProjectListSectionContainer>
      {data.independentProjects?.length ? (
        <>
          <ProjectSectionHeader>
            <div>
              <ProjectSectionTitle>Independent Project</ProjectSectionTitle>
            </div>
            <ProjectViewControls aria-label="Independent project view">
              <ProjectViewButton
                type="button"
                aria-pressed={view === "list"}
                onClick={() => setView("list")}
              >
                List
              </ProjectViewButton>
              <ProjectViewButton
                type="button"
                aria-pressed={view === "gallery"}
                onClick={() => setView("gallery")}
              >
                Gallery
              </ProjectViewButton>
            </ProjectViewControls>
          </ProjectSectionHeader>
          <ProjectCompanyContainer view={view}>
            <ProjectCompanyHeader view={view}>
              <ProjectCompanyName view={view}>Hagah</ProjectCompanyName>
              <ProjectCompanyTimeline view={view}>2026</ProjectCompanyTimeline>
            </ProjectCompanyHeader>
            <ProjectCardList view={view}>
              {renderProject(data.independentProjects, view)}
            </ProjectCardList>
          </ProjectCompanyContainer>
        </>
      ) : null}
      <ProjectSectionHeader>
        <div>
          <ProjectSectionTitle>Selected Work</ProjectSectionTitle>
        </div>
        <ProjectViewControls aria-label="Selected work view">
          <ProjectViewButton
            type="button"
            aria-pressed={view === "list"}
            onClick={() => setView("list")}
          >
            List
          </ProjectViewButton>
          <ProjectViewButton
            type="button"
            aria-pressed={view === "gallery"}
            onClick={() => setView("gallery")}
          >
            Gallery
          </ProjectViewButton>
        </ProjectViewControls>
      </ProjectSectionHeader>
      {renderCompanies(view)}
    </ProjectListSectionContainer>
  );
};

export default ProjectListSection;
